module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('address-form', {
    attrs: {
      "back": _vm.back,
      "next": _vm.nextUrl
    },
    on: {
      "saved": _vm.onSave
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1308b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressPage.vue
// module id = 1152
// module chunks = 0